export default __webpack_public_path__ + "608d0fec29c9ae6b3e40fe6f587af0f2.png";